import React from 'react';
import { autoCreateQuery as personAutoCreate, client as personClient } from '../../common/components/person/person';
import { ENTITY_CONSTANTS } from '../../common/constants/entityConstants';
import { FORM_WIDGET_COMPONENTS } from '../../common/form/formConstants';
import { FormContainer } from '../../common/form/FormContainer';
import FormItem from '../../common/form/FormItem';
import FormPanel from '../../common/form/FormPanel';
import FormWidget from '../../common/form/FormWidget';
import { useMutationWithContext } from '../../common/hooks/useMutationWithContext';
import I18n from '../../common/i18n/I18n';
import { quickAddPerson } from '../../person/helpers/QuickAddPerson';
import InquiryDateRangeFormItem from './inquiry/InquiryDateRangeFormItem';
import InquiryProductionFormItems from './inquiry/InquiryProductionFormItems';
import PersonFormField from './PersonFormField';

export default ({
    productionName,
    productionOptions,
    productionDateRange,
    isRequestAvailsForUser = false,
    filters = undefined,
    saveAttachmentTags,
    onDeleteAttachmentFromState,
    setIsInUploadMode,
    showCandidateListOnly = false
}) => {
    const [savePerson] = useMutationWithContext(personAutoCreate, personClient);

    return (
        <FormPanel sx={{ height: '100%', overflow: 'auto' }}>
            {showCandidateListOnly ? (
                <PersonFormField
                    isRequestAvailsForUser={isRequestAvailsForUser}
                    filters={filters}
                    savePerson={savePerson}
                    quickAddPerson={quickAddPerson}
                />
            ) : (
                <>
                    <PersonFormField
                        isRequestAvailsForUser={isRequestAvailsForUser}
                        filters={filters}
                        savePerson={savePerson}
                        quickAddPerson={quickAddPerson}
                        isMultiple
                    />
                    <FormContainer>
                        <InquiryProductionFormItems
                            productionOptions={productionOptions}
                            productionName={productionName}
                            isRequestAvailsForUser={isRequestAvailsForUser}
                        />
                    </FormContainer>
                    <FormContainer>
                        <FormItem half>
                            <FormWidget
                                name="role"
                                label={<I18n token="form.resource.role" />}
                                component="MetadataAutocomplete"
                                metadataName="Role"
                                disabled
                            />
                        </FormItem>
                        <FormItem half>
                            <FormWidget
                                component="Location"
                                name="locations"
                                label={<I18n token="form.resource.locations" />}
                                multiple
                                limitTags={1}
                            />
                        </FormItem>
                    </FormContainer>
                    <FormContainer>
                        <FormItem>
                            <FormWidget
                                name="productionSummary"
                                component={'TextArea'}
                                label={<I18n token="shortlist.lineItem.person.production.summary" />}
                                minRows={3}
                            />
                        </FormItem>
                    </FormContainer>
                    <InquiryDateRangeFormItem dateRange={productionDateRange} />
                    <FormContainer>
                        <FormItem>
                            <FormWidget
                                name="personalizedMessage"
                                component={'TextArea'}
                                label={<I18n token="shortlist.lineItem.person.personalizedMessage" />}
                                minRows={3}
                            />
                        </FormItem>
                    </FormContainer>
                    <FormItem>
                        <FormWidget
                            component={FORM_WIDGET_COMPONENTS.attachments}
                            label={<I18n token="attachments.title" />}
                            name={'attachments'}
                            entity={ENTITY_CONSTANTS.shortlistLineitem}
                            onDeleteAttachments={onDeleteAttachmentFromState}
                            onSaveAttachments={(entityId, inputs) => saveAttachmentTags(inputs)}
                            setIsInUploadMode={setIsInUploadMode}
                        />
                    </FormItem>
                </>
            )}
        </FormPanel>
    );
};
